import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function registerDataReducer(
  state = initialState.userRegister,
  action
) {
  switch (action.type) {
    case types.LOAD_REGISTER_DATA_SUCCESS:
      return action.userRegister;
    default:
      return state;
  }
}
